import type { UseQueryOptions } from '@tanstack/react-query';
import type { ShopInfo } from '~/types/shop';

import { useQuery } from '@tanstack/react-query';
import { fetchFromAPI } from '~/api/utils';

const queryKey = 'shopInfo';
export type ShopInfoQueryResponse = ShopInfo;
export type ShopInfoQueryVariables = undefined;
export const useShopInfoQuery = <TError = Error, TData = ShopInfoQueryResponse>(
  variables?: ShopInfoQueryVariables,
  options?: UseQueryOptions<ShopInfoQueryResponse, TError, TData>,
) => {
  return useQuery<ShopInfoQueryResponse, TError, TData>({
    queryKey: [queryKey, variables],
    queryFn: () => fetchFromAPI('/api/shop', { method: 'GET' }),
    ...options,
  });
};
useShopInfoQuery.getKey = (variables: ShopInfoQueryVariables) => [queryKey, variables];
